import * as React from "react";
function SvgViewOn(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.447 12.338A14.627 14.627 0 014.201 12a15.81 15.81 0 011.964-2.276C7.662 8.298 9.675 7 12 7s4.338 1.298 5.835 2.724A15.81 15.81 0 0119.8 12a15.81 15.81 0 01-1.964 2.276C16.338 15.702 14.325 17 12 17s-4.338-1.298-5.835-2.724a15.81 15.81 0 01-1.718-1.938zM21 12l.857-.515L21 12zm.856-.518l.001.003.31.515-.31.514L21 12c.858.514.857.515.857.516l-.001.002-.004.005-.01.018a15.68 15.68 0 01-.688.997 17.808 17.808 0 01-1.94 2.186C17.563 17.298 15.076 19 12 19s-5.562-1.702-7.215-3.276a17.802 17.802 0 01-2.453-2.913 10.463 10.463 0 01-.17-.264l-.003-.006-.011-.018-.003-.005-.002-.004L3 12l-.857-.516.002-.002.003-.005.01-.018.038-.06a15.706 15.706 0 01.651-.937 17.813 17.813 0 011.938-2.186C6.438 6.702 8.925 5 12 5s5.562 1.702 7.215 3.276a17.82 17.82 0 012.453 2.913 10.185 10.185 0 01.174.27l.01.018.004.005zM3 12l-.857-.515-.31.515.31.514L3 12zm7 0a2 2 0 114 0 2 2 0 01-4 0zm2-4a4 4 0 100 8 4 4 0 000-8z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgViewOn);
export default ForwardRef;
